import { AppModule } from './app/app.module';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { cgpAuthentication } from './modules/cgp-authentication';
import { setEnv, ENV } from './modules/utility';

import { environment } from './environments/environment';

if (environment.production) {
    enableProdMode();
}

ENV.subscribe(x => {
    if (x === '') {
        cgpAuthentication.updateMescLoading("MESC is unavailable. Please contact technical support and try again");
        return;
    } else if (x) {
        cgpAuthentication.validateToken(() => {
            cgpAuthentication.getUserProfile(() => {
                platformBrowserDynamic()
                .bootstrapModule(AppModule)
                .catch(err => console.error(err));
            });
        });
    }
});

setEnv();
